var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcessMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 682.667 682.667",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 512h512V0H0Z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 682.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c32.089 92.592 119.323 154.684 217.319 154.684 104.849 0 196.427-70.91 222.676-172.421",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(41.5 342.316)",
    fill: "none",
    stroke: "#999999",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 18.934-44.866 44.867 18.937",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(15 370.254)",
    fill: "none",
    stroke: "#999999",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-32.089-92.592-119.323-154.684-217.319-154.684-104.849 0-196.427 70.91-222.676 172.421",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(470.5 169.684)",
    fill: "none",
    stroke: "#999999",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-18.934 44.865-44.867-18.936",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(497 144.786)",
    fill: "none",
    stroke: "#999999",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a115.37 115.37 0 0 0 28.032-11.616l5.961 5.961c11.667 11.667 30.759 11.667 42.426 0l.001-.001c11.667-11.667 11.667-30.759 0-42.426l-5.961-5.96a115.285 115.285 0 0 0 11.617-28.033H90.5c16.5 0 30-13.5 30-30 0-16.501-13.5-30-30-30h-8.424a115.246 115.246 0 0 0-11.617-28.033l5.961-5.96c11.667-11.667 11.667-30.759 0-42.426v-.001c-11.668-11.667-30.76-11.667-42.427 0l-5.961 5.961A115.298 115.298 0 0 0 0-224.15v-8.425c0-16.501-13.5-30-30-30s-30 13.499-30 30v8.425a115.354 115.354 0 0 0-28.032 11.616l-5.961-5.961c-11.668-11.667-30.76-11.667-42.427 0-11.667 11.668-11.667 30.759 0 42.427l5.96 5.96a115.282 115.282 0 0 0-11.616 28.033h-8.424c-16.501 0-30 13.499-30 30 0 16.5 13.499 30 30 30h8.424a115.246 115.246 0 0 0 11.617 28.033l-5.961 5.96c-11.667 11.667-11.667 30.759 0 42.427 11.668 11.667 30.76 11.667 42.427 0l5.961-5.961A115.315 115.315 0 0 0-60 0v8.425c0 16.5 13.5 30 30 30s30-13.5 30-30z",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(286 368.075)",
    fill: "none",
    stroke: "#999999",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c16.523 0 30 13.477 30 30S16.523 60 0 60s-30-13.477-30-30S-16.523 0 0 0Z",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(256 226)",
    fill: "none",
    stroke: "#999999",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessMaster);
export default __webpack_public_path__ + "static/media/process-master.a322ecb4da17d4cf7de3fddce806d83f.svg";
export { ForwardRef as ReactComponent };